// removed by extract-text-webpack-plugin
module.exports = {"saml-service-provider-form":"saml-service-provider-form","samlServiceProviderForm":"saml-service-provider-form","saml-download-metadata":"saml-download-metadata","samlDownloadMetadata":"saml-download-metadata","saml-update-service-provider-button-wrapper":"saml-update-service-provider-button-wrapper","samlUpdateServiceProviderButtonWrapper":"saml-update-service-provider-button-wrapper","saml-update-service-provider-button":"saml-update-service-provider-button","samlUpdateServiceProviderButton":"saml-update-service-provider-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/saml/serviceProviderForm/style.scss
// module id = 1451
// module chunks = 0